<template lang="pug">
  .TopInformations(:class="backgroundClass(title)")
    div
      h1 {{ title }}
      h2 {{ subtitle }}
      p {{ text }}
</template>

<script>
  export default {
    name: "TopInformations",
    props: {
      title: String,
      subtitle: String,
      text: String,
    },
    methods: {
      backgroundClass(title) {
        const backgroundClassList = {
          人脸识别: 'faceSaaSBG',
          精准营销: 'marketingBG',
          个性化推荐: 'recommendationBG',
          数字城市: 'digitalCityBG',
          数字教育: 'digitalEducationBG',
          服务套餐: 'price',
        };
        return backgroundClassList[title]
      }
    }
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .faceSaaSBG {     // 人脸识别
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E4%BA%BA%E8%84%B8%E8%AF%86%E5%88%AB%E5%BA%95%E6%9D%BF2.png")
  }
  .marketingBG {    // 精准营销
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E7%B2%BE%E5%87%86%E8%90%A5%E9%94%80%E5%A4%B4%E9%83%A8banner.png")
  }
  .recommendationBG { // 个性化推荐
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E4%B8%AA%E6%80%A7%E5%8C%96%E6%8E%A8%E8%8D%90banner.png")
  }
  .digitalCityBG {  // 数字城市
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E6%95%B0%E5%AD%97%E5%9F%8E%E5%B8%82%E5%BA%95%E6%9D%BF.png")
  }
  .digitalEducationBG {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E6%95%B0%E5%AD%97%E6%95%99%E8%82%B2banner.png")
  }
  .price {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E5%AE%9A%E4%BB%B7%E9%A1%B5%E9%9D%A2banner.png")
  }
  .TopInformations {
    background-repeat no-repeat
    background-position center
    background-color #3a3c56
    height (600 / 1920)*100vw
    background-size 100%
    width 100%
    color white
    position relative
    
    h1, h2, p {
      color white
      padding 0
      margin 0
    }
    h1{
      font-size 82px
      FontSetting("思源黑体 CN Heavy")
      &::before
      &::after {
        content none
      }
    }
    h2 {
      font-size 32px
      FontSetting("思源黑体")
      font-weight 300
      padding-top 10px
      padding-right 10px
    }
    p {
      font-size 20px
      FontSetting(Montserrat)
      font-weight 200
      padding-top 6px
      padding-right 10px
      letter-spacing .5px
      color #2d9eff
    }
    > div {
      position absolute
      height 190px
      top calc(50% - 95px)
      left 110px
      VStack(flex-end, flex-end)
    }
    @media (max-width 1920px) {
      height 600px
      background-size auto 100%
    }
  }
  @media (max-width ipadProScreenWidth) {
    .TopInformations {
      >div {
        left 100px
        bottom 50px
      }
    }
  }
  @media (max-width screenWidth) {
    .TopInformations {
      height 420px
      background-size auto 520px
      background-position-y bottom
      > div {
        top auto
        bottom 30px
        left 0px
        padding 0 20px
        align-items flex-start
        h1 {
          font-size 40px
        }
        h2 {
          font-size 26px
        }
        p {
          font-size 14px
        }
      }
    }
    .faceSaaSBG {
      background-position-x -808px
    }
    .marketingBG {    // 精准营销
      background-position-x -760px
    }
    .recommendationBG { // 个性化推荐
      background-position-x -1157px
    }
    .digitalCityBG {  // 数字城市
      background-position-x -940px
    }
    .digitalEducationBG {
      background-position-x -1013px
      background-position-y -50px
    }
    .price {
      background-position-x right
      background-position-y top
    }
  }
</style>
